import axios from 'axios'

export default {
  install (Vue) {
    const setToken = function (token, expired, userName) {
      axios.defaults.headers.common['Authorization'] = token
      localStorage.setItem('token', token)
      localStorage.setItem('expired', expired)
      localStorage.setItem('userName', userName)
    }

    const clearToken = function () {
      axios.defaults.headers.common['Authorization'] = undefined
      localStorage.removeItem('token')
      localStorage.removeItem('expired')
      localStorage.removeItem('userName')
    }

    const checkToken = function () {
      return localStorage.getItem('token') &&
        localStorage.getItem('expired') > Date.now() / 1000
    }

    Vue.prototype.checkToken = checkToken
    Vue.prototype.clearToken = clearToken
    Vue.prototype.setToken = setToken
  }
}
